module.exports = __webpack_public_path__ + "static/img/アセット 75@3x.fcfabef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 75@3x.png
// module id = TL78
// module chunks = 1